export const getAccountsSummaryCount = {
    GET_ACCOUNTS_SUMMARY_COUNT_REQUEST: "GET_ACCOUNTS_SUMMARY_COUNTS_REQUEST",
    GET_ACCOUNTS_SUMMARY_COUNT_SUCCESS: "GET_ACCOUNTS_SUMMARY_COUNT_SUCCESS",
    GET_ACCOUNTS_SUMMARY_COUNT_ERROR: "GET_ACCOUNTS_SUMMARY_COUNT_ERROR",
  };

export const getGroupWiseAccountsCount = {
  GET_GROUP_WISE_ACCOUNTS_COUNT_REQUEST: "GET_GROUP_WISE_ACCOUNTS_COUNT_REQUEST",
  GET_GROUP_WISE_ACCOUNTS_COUNT_SUCCESS: "GET_GROUP_WISE_ACCOUNTS_COUNT_SUCCESS",
  GET_GROUP_WISE_ACCOUNTS_COUNT_ERROR: "GET_GROUP_WISE_ACCOUNTS_COUNT_ERROR",
};
  